import { jsx } from '@emotion/core';
import { background } from '@atlaskit/theme/colors';
import { BORDER_WIDTH } from './constants';
var IconWrapper = function (_a) {
    var bgColor = _a.bgColor, children = _a.children;
    return (jsx("span", { css: {
            alignContent: 'center',
            alignItems: 'center',
            backgroundColor: bgColor || background(),
            borderRadius: '50%',
            boxSizing: 'border-box',
            display: 'flex',
            height: '100%',
            overflow: 'hidden',
            border: BORDER_WIDTH + "px solid " + (bgColor || background()),
            width: '100%',
        } }, children));
};
export default IconWrapper;
//# sourceMappingURL=IconWrapper.js.map